import { cookieDisclaimerActionTypes } from './cookieDisclaimerActions';
const COOKIE_DISCLAIMER_INITIAL_STATE = {
  isInitialized: false,
  runningTime: 0
};

function setState(state, newState){
  return { ...state, ...newState }
}

const {
  COOKIE_DISCLAIMER
} = cookieDisclaimerActionTypes;

export function cookieDisclaimerReducer(state = COOKIE_DISCLAIMER_INITIAL_STATE, action){
  switch (action.type) {
    case COOKIE_DISCLAIMER.GET_DONT_SHOW_FLAG:
    case COOKIE_DISCLAIMER.TIME.START_INTERVAL:
    case COOKIE_DISCLAIMER.CLOSE.FOREVER:
    case COOKIE_DISCLAIMER.CLOSE.UNTIL_RELOAD:
    case COOKIE_DISCLAIMER.TIME.UPDATE:
      return setState(state, action.state);
    default:
  }
  return state;
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookieDisclaimer/cookieDisclaimerReducer.js